import { useRef } from "react";
import { useUIStore } from "../../store/uiStore";

const DRAG_INTENT_PX = 8;

/**
 * Locked blocks have dragging disabled at the dnd-kit level, so an attempted
 * drag would otherwise die silently. This probe watches for drag intent
 * (pointer down + movement) and surfaces the standard locked prompt instead.
 */
export function useLockedDragProbe(enabled: boolean, message: string) {
  const origin = useRef<{ x: number; y: number } | null>(null);
  const prompted = useRef(false);

  if (!enabled) return {};

  return {
    onPointerDown: (e: React.PointerEvent) => {
      origin.current = { x: e.clientX, y: e.clientY };
      prompted.current = false;
    },
    onPointerMove: (e: React.PointerEvent) => {
      if (!origin.current || prompted.current) return;
      const dx = e.clientX - origin.current.x;
      const dy = e.clientY - origin.current.y;
      if (Math.hypot(dx, dy) > DRAG_INTENT_PX) {
        prompted.current = true;
        useUIStore.getState().showLockedActionPrompt(message);
      }
    },
    onPointerUp: () => {
      origin.current = null;
    },
    onPointerCancel: () => {
      origin.current = null;
    },
  };
}
